document.addEventListener('alpine:init', () => {
Alpine.store('notifications', {
    visible: false,
    duration: 5000,
    htmlContent: '',
    open(htmlContent) {
        this.visible = true;
        this.htmlContent = htmlContent;
      var _this = this
      this.afterRun(() => {
        _this.visible = false;
        this.afterRun(() => {
          _this.htmlContent = null;
        });
      });
    },
    close() {
      this.visible = false;
      var _this = this
      setTimeout(() => {
        _this.htmlContent = false;
      }, this.duration);
    },
    afterRun(func) {
      var _this = this;
      setTimeout(() => {
        func()
      }, this.duration);
    }
  });


});